// Alto de body+CTA de partida (px fijos, no escala con el ancho de columna):
// padding body (32) + etiqueta (~28) + título 2 líneas (~48) + fecha (~20) +
// recinto (~16) + precio (~20) + huecos (~36) + CTA (40). Es solo el punto de
// arranque: `VirtualizedList` mide el alto real de cada fila con `ResizeObserver`
// y corrige el hueco entre filas en cuanto se renderiza, así que ya no depende de
// que esta cifra sea exacta. Compartido por todas las PLP virtualizadas (agenda,
// lo-más-vendido, search, postsale, subcategoría), que usan las mismas cards.
const CONTENT_HEIGHT_ESTIMATE = 240

/** Imagen a ratio cuadrado (1:1, `VerticalCard`) ⇒ alto = ancho. */
const IMAGE_ASPECT_RATIO = 1

/**
 * Alto de fila estimado (px) para una columna de este ancho, según el diseño de
 * `VerticalCard` (imagen cuadrada + cuerpo/CTA). Función estable a nivel de módulo
 * (no una arrow inline): `useResponsiveColumns` la vuelve a enganchar en su efecto
 * de resize si la referencia cambia entre renders.
 */
export function estimateRowHeight(columnWidth: number): number {
  return Math.ceil(columnWidth * IMAGE_ASPECT_RATIO) + CONTENT_HEIGHT_ESTIMATE
}

// Vista horizontal (lista, 1 columna): `HorizontalCard` pone la imagen cuadrada
// al 40% del ancho de fila y el contenido a la derecha — el alto de fila es el
// mayor entre el de la imagen y el del contenido.
const HORIZONTAL_IMAGE_WIDTH_RATIO = 0.4
const HORIZONTAL_CONTENT_HEIGHT_ESTIMATE = 200

export function estimateHorizontalRowHeight(rowWidth: number): number {
  const imageHeight = Math.ceil(rowWidth * HORIZONTAL_IMAGE_WIDTH_RATIO)
  return Math.max(imageHeight, HORIZONTAL_CONTENT_HEIGHT_ESTIMATE)
}
